<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title has-text-weight-medium">
                Please pay &pound;{{ balance | currency }}
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="$parent.close()"
            />
        </header>
        <section class="modal-card-body">
            <h5
                v-if="balance"
                class="title is-5"
            >
                Pay securely online:
            </h5>

            <p v-if="link && canPayOnline">
                <b-button
                    type="is-info"
                    tag="router-link"
                    rounded
                    :to="linkWithAmount"
                    @click.native="$parent.close()"
                >
                    Pay online
                </b-button>
            </p>

            <div v-if="$meta.features.tenants.bank_account">
                <hr v-if="canPayOnline" />

                <h5
                    v-if="canPayOnline"
                    class="title is-5"
                >
                    Alternatively, pay by bank transfer:
                </h5>

                <BankDetails />

                <p class="mt-2">
                    Please use a recognisable reference,
                    such as your surname and/or property road name.
                </p>
            </div>
        </section>
    </div>
</template>

<script>
import BankDetails from './BankDetails';

export default {
    components: {
        BankDetails,
    },

    props: {
        balance: {
            type: [String, Number],
            default: 0,
            required: false,
        },
        link: {
            type: [Object, Boolean],
            required: false,
            default: false,
        },
    },

    computed: {
        canPayOnline: function () {
            return this.$meta.features.tenants.online_payments;
        },
        linkWithAmount: function () {
            let link = this.link;

            if(this.balance) {
                link.query = {};
                link.query.amount = this.balance;
            }

            return link;
        },
    },
};
</script>
